import { render, staticRenderFns } from "./WeekRooms.vue?vue&type=template&id=2a05e67f&scoped=true&"
import script from "./WeekRooms.vue?vue&type=script&lang=js&"
export * from "./WeekRooms.vue?vue&type=script&lang=js&"
import style0 from "./WeekRooms.vue?vue&type=style&index=0&id=2a05e67f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a05e67f",
  null
  
)

export default component.exports